/* 供应商建品相关接口 */

// 获取产地信息列表
export function getAllCityInfo() {
    return this.$post({
        url: '/api/vss/shepherd/product/getAllCityInfo',
    });
}

// 获取品牌信息列表
export function getAllBrandInfo() {
    return this.$get({
        url: '/api/vss/shepherd/product/getAllValidBrand',
    });
}

// 查自编条码
export function getOnlyOneValidCode(body) {
    return this.$post({
        url: '/api/vss/shepherd/product/getOnlyOneValidCode',
        body,
    });
}

// 单位列表查询
export function listAllUnit(body) {
    return this.$post({
        url: '/api/vss/shepherd/product/listAllUnit',
        body,
    });
}

// 详情
export function fetchNewSellDetail(body) {
    return this.$hPost('/api/vss/shepherd/product/bizcenter/VssNewSaleQueryTService/queryDetail', body);
}

// 保存草稿
export function saveNewSellDraft(body) {
    return this.$hPost('/api/vss/shepherd/product/bizcenter/VssNewSaleCommandTService/saveDraft', body);
}

// 提报
export function submitNewSell(body) {
    return this.$hPost('/api/vss/shepherd/product/bizcenter/VssNewSaleCommandTService/submitNewSale', body);
}

// 查询所有经营城市，默认关闭启数据权限 --提报信息tab
export function getManagementCityList(body = { usePermission: false }) {
    body.includeTestPoi = true;
    return this.$hPost('/api/vss/shepherd/supplier/poi/getAllManagerCity', body);
}

// 查询供应商指定品类的可供城市列表 --提报信息tab
export function getCapableCityList(body) {
    return this.$hPost('/api/vss/shepherd/product/queryCapableCityList', body);
}

// 根据分类id查询扩展属性列表
export function getNewExtAttrByCategoryId(body) {
    return this.$hPost('/api/vss/shepherd/product/queryExtAttrByBgCategory', body);
}

// 基础库列表
export function getNewSkuBaseList(body) {
    return this.$hPost('/api/vss/shepherd/product/suggestSpuByName', body);
}

// 获取上新提报 审批驳回后，不可编辑的字段
export function queryCreateNewRejectedCannotEditAttrs(body) {
    return this.$hPost('/api/vss/shepherd/product/newSaleApply/queryFormRules', body);
}

// 查询配置信息-包括内容tab是否必填，某些字段是否必填等
export function queryCategoryConfigByApplyId({ applyId }) {
    const body = {
        applyId,
        needQueryField: {
            requireContentSection: true,
            requireSupplierManufacture: true,
            requireLicenseValidPeriodRule: true,
            requireProcessTaskRole: true,
            requireCanChangeEditor: true,
        },
    };
    return this.$hPost('/api/vss/shepherd/product/bizcenter/VssNewSaleQueryTService/querySpec', body);
}

// 根据后台分类查命名规范配置
export function queryBgCategoryConfig(body) {
    return this.$hPost('/api/vss/shepherd/product/bizcenter/IFlowQueryTService/queryFlowSpecByBgCategory', body);
}

// 根据管理类目获取mis是否必填
export function getMisRequired(body) {
    return this.$hPost('/api/vss/shepherd/product/queryFlowSpecByMgCategory', body);
}

// 图像识别，根据条形码和实物图，校验是否匹配 http://yapi.sankuai.com/thrift/project/12854/interface/api/1992380
export function validCodeByPhysicalPictures(body) {
    return this.$hPost('/api/vss/shepherd/ApprovalFlowQueryTService/validProductInfoByPhysicalPictures', body);
}

// 根据后台类目查DNA属性
export function getDnaAttrsByBgCategoryId(body) {
    return this.$hPost('/api/vss/shepherd/product/bizcenter/IFlowQueryTService/queryDnaAttrDetailInfoByBgCategory', body);
}

// 提交前预校验接口
export function getPreSubmitCheck(body) {
    return this.$hPost('/api/vss/shepherd/product/bizcenter/VssNewSaleQueryTService/preVerifyNewSale', body);
}
